<template>
  <v-container fluid class="pa-0 vendor-form-shell">
    <v-card class="rounded-xl" elevation="0">
      <v-card-title class="vendor-form-title">
        <span v-if="isUpdating">Vendor Detail</span
        ><span v-else>New Vendor</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="isFormValid">
          <v-text-field
            :rules="nameRules"
            class="mb-2"
            dense
            rounded
            outlined
            hide-details
            label="Full Name"
            v-model="vendor.name"
          ></v-text-field>
          <v-text-field
            v-if="!isUpdating"
            class="mb-2"
            dense
            rounded
            outlined
            hide-details
            label="Address 1"
            v-model="vendor.address1"
          ></v-text-field>
          <v-text-field
            v-if="!isUpdating"
            class="mb-2"
            dense
            rounded
            outlined
            hide-details
            label="Address 2"
            v-model="vendor.address2"
          ></v-text-field>
          <v-text-field
            class="mb-2"
            dense
            rounded
            outlined
            hide-details
            label="Email"
            v-model="vendor.email"
          ></v-text-field>
          <v-text-field
            label="Phone"
            v-model="vendor.phone"
            dense
            rounded
            outlined
            hide-details
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="vendor-form-actions">
        <v-spacer></v-spacer>
        <v-btn
          v-if="isUpdating"
          :block="$vuetify.breakpoint.smAndDown"
          color="primary"
          depressed
          rounded
          @click="updateVendor"
          :loading="isLoading"
          ><i class="fas fa-save mr-2"></i>Update</v-btn
        >
        <v-btn
          v-else
          :block="$vuetify.breakpoint.smAndDown"
          color="primary"
          depressed
          rounded
          @click="addVendor"
          :loading="isLoading"
          :disabled="!isFormValid"
          ><i class="fas fa-user-plus mr-2"></i>Submit</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import backendService from "@/services/backend-service";
import generalMixin from "@/js/general-mixin";
import formMixin from "@/js/form-mixin";

export default {
  name: "CustomerForm",
  mixins: [generalMixin, formMixin],
  mounted: function () {
    this.$refs.form.validate();
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isUpdating: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    vendor: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    addVendor() {
      this.isLoading = true;
      backendService
        .addVendor(this.vendor)
        .then((response) => {
          this.$store.commit("addVendor", response.data);
          this.timer(1000).then(() => {
            this.isLoading = false;
            this.vendor = {};
            this.$refs.form.reset();
            this.input = false;
            this.$emit("handle-event");
            this.successSnackbar("Successfully added a new vendor");
          });
        })
        .catch(() => {
          this.timer(1000).then(() => {
            this.isLoading = false;
            this.errorSnackbar("Ops! Something is not right");
          });
        });
    },
    getVendorName(vendor) {
      if (!vendor) return "";
      if (vendor) {
        return `${vendor.name} - ${vendor.phone}`;
      }
      return "";
    },
    getCustomerById(id) {
      backendService.getCustomerById(id).then((response) => {
        this.vendor = response.data;
      });
    },
    updateVendor() {
      this.isLoading = true;
      backendService
        .updateVendor(this.vendor)
        .then(() => {
          this.$store.commit("updateVendor", this.vendor);
          this.timer(1000).then(() => {
            this.isLoading = false;
            this.$emit("handle-event");
            this.successSnackbar("Successfully updated vendor");
          });
        })
        .catch(() => {
          this.isLoading = false;
          this.errorSnackbar("Ops! Something is not right");
        });
    },
  },
};
</script>
<style scoped>
.vendor-form-shell {
  max-width: 600px;
  overflow: hidden;
}
.vendor-form-title {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.25;
  padding-bottom: 12px;
}
.vendor-form-actions {
  padding: 0 16px 16px;
}
</style>
